import { FC, ReactNode } from "react";
import { useNavigationState } from "@/router/hooks/useNavigationState";
import { SkeletonList } from "@/shared/ui/SkeletonList";

interface Props {
  children: ReactNode;
  skeletonLength?: number;
}

export const PageLoader: FC<Props> = ({ children, skeletonLength = 5 }) => {
  const { pageLoading } = useNavigationState();

  return (
    <>
      {pageLoading && (
        <div className="flex-1 px-4 py-6">
          <div className="lgc:max-w-[var(--content-width)] mx-auto">
            <SkeletonList length={skeletonLength} height="h-12" />
          </div>
        </div>
      )}
      {!pageLoading && children}
    </>
  );
};
